import { Injectable } from '@angular/core';
import { HttpResponse } from '../../../common/models/dto/http-response';
import { PraticaLight } from '../../../common/models/pratica/pratica-light';
import { CategoriaFaccetta } from '../../../search/faccette/categoria-faccetta';
import { DocumentoLight } from '../documento/documento-light';
import { SearchCriteria } from '../search-criteria';
import { Adempimento } from '../adempimento';
import { Atto } from '../atto';

@Injectable()
export class SearchResponse extends HttpResponse {
  includeDocuments: boolean;
  includePratiche: boolean;
  nomeCampoOrdinamentoPratiche: string;
  nomeCampoOrdinamentoDocumenti: string;
  searchCriteria: SearchCriteria;
  pratiche: PraticaLight[];
  documenti:  DocumentoLight[];
  adempimenti: Adempimento[];
  nomiCampiDocumentoOrdinabili: string;
  nomiCampiPraticaOrdinabili: string;
  faccetteApplicabili: CategoriaFaccetta[];
  numeroDocumentiTrovati: string;
  numeroDocumentiTotali: string;
  numeroPraticheTrovate: string;
  numeroPraticheTotali: string;
  numeroFascicoliTrovati: string;
  numeroFascicoliTotali: string;
  numeroAdempimentiTrovati: string;
  numeroAdempimentiTotali: string;
  numeroAdempimentiPubbliciTrovati: number;
  numeroAdempimentiPubbliciTotali: number;
  numeroAdempimentiPrivatiTrovati: number;
  numeroAdempimentiPrivatiTotali: number;
  numeroAttiTrovati: string;
  numeroAttiTotali: string;
  nextView: string;
  atti:Atto[];
  constructor() {
    super();
    this.searchCriteria = new SearchCriteria();
  };
}
